import api from '../../api'
import {
  GET_DISTRIBUTION_LIST_SUCCESS,
  GET_DISTRIBUTION_LIST_FAILURE,
  GET_DISTRIBUTION_FAILURE,
  GET_DISTRIBUTION_SUCCESS,
  UPDATE_DISTRIBUTION_SUCCESS,
} from '../types'

const state = {
  list: [],
  listUpdated: (new Date()),
  toValidateList: [],
  selected: null,
  selectedUpdated: (new Date())
};


const actions = {

  
  getDistributionList({commit}, query) {
    return new Promise((resolve, reject) => {

    api.startLoader()
    api.getDistributionList(query).then(response => {
      if (!response.ok) {
        api.stopLoader()
         commit(GET_DISTRIBUTION_LIST_FAILURE)
         return reject(response.body.$error)

      }
      commit(GET_DISTRIBUTION_LIST_SUCCESS, {
        distributionList: response.body.data
      })
      api.stopLoader()
      return resolve(response.body.data)

    }, response => {
      api.stopLoader()
      commit(GET_DISTRIBUTION_LIST_FAILURE)
      return reject(response.body.$error)

    })
  })
  },
 
  cleanDistributionList({commit}) {
    return commit(GET_DISTRIBUTION_LIST_FAILURE)
  },
  
  getDistribution({commit}, ud) {
    return new Promise((resolve, reject) => {

      api.getDistribution(ud)
        .then(response => {
          console.log(response);
          if (!response.ok) {
            commit(GET_DISTRIBUTION_FAILURE);
            reject();
          }
          commit(GET_DISTRIBUTION_SUCCESS, {
            distribution: response.body
          });
          resolve(response.body);
        }, response => {
          commit(GET_DISTRIBUTION_FAILURE);
          reject();
        })
    })
  },
 
  
  updateDistribution({commit}, data) {
    return new Promise((resolve, reject) => {

      api.startLoader()
      let avaliables = [
        "id",
        "name",
      ];

      let obj = {};

      for (let i of avaliables) {
        if (data.hasOwnProperty(i)) {
          obj[i] = data[i];
        }
      }

          api.updateDistribution(obj)
            .then(response => {
              if (!response.ok) {
                api.stopLoader()
                return reject(response.body.$error);
              } else {
                api.stopLoader()
                return resolve(response.body.$success);
              }
            }, response => {
              api.stopLoader()
              return reject(response.body.$error);
            })
      
    })
  },
  createDistribution({commit}, data) {
    return new Promise((resolve, reject) => {
      api.startLoader()
      api.createDistribution(data)
        .then(response => {
          if (!response.ok) {
            api.stopLoader()
            return reject(response.body.$error);
          } else {
            api.stopLoader()
            return resolve(response.body.$success);
          }
        }, response => {
          api.stopLoader()
          return reject(response.body.$error);
        })
    })
  },
  
  
 
  deleteDistribution({commit}, data) {
    return new Promise((resolve, reject) => {
      api.startLoader()
      api.deleteDistribution(data)
        .then(response => {
          if (!response.ok) {
            api.stopLoader()
            return reject(response.body.$error);
          } else {
            api.stopLoader()
            return resolve(response.body.$success);
          }
        }, response => {
          api.stopLoader()
          return reject(response.body.$error);
        })
    })
  },

  
  
};

const mutations = {

  [UPDATE_DISTRIBUTION_SUCCESS](state, action) {
    state.selected = JSON.parse(JSON.stringify(action.distribution));
  },
  [GET_DISTRIBUTION_LIST_FAILURE](state) {
    state.list = []
  },
  [GET_DISTRIBUTION_LIST_SUCCESS](state, action) {
    state.list = action.distributionList;
    state.listUpdated = new Date();
  },
  [GET_DISTRIBUTION_FAILURE](state) {
    state.selected = null
  },
  [GET_DISTRIBUTION_SUCCESS](state, action) {
    state.selected = JSON.parse(JSON.stringify(action.distribution));
  },
};

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/distribution.js